<ng-container *transloco="let t; read: 'accounts'">
<div>
  <div class="flex justify-between border-b">
    <h1 class="text-[25px] font-bold">{{modalHeader}}</h1>
    <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
  </div>

  <div mat-dialog-content>
    <div class="content">
      @if (!createPassword) {
        <p class="pt-5 pb-3">
          {{ t('resetPassword.confirm') }}
        </p>
      } @else {
        <form [formGroup]="resetPwForm">
          <div class="flex flex-row justify-center">
            <div>
              <div
                class="flex my-6 border rounded-lg border-drdpblue-300 shadow-drdpblue-100">
                <div
                  class="rounded-l basis-1/12 flex items-center justify-center bg-drdpblue-300 text-white">
                  <i class="uil uil-lock"></i>
                </div>
                <input
                  class="form-control basis-11/12 appearance-none w-5/6 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  maxlength="250"
                  [placeholder]="t('resetPassword.newPasswordPlaceholder')"
                  [type]="inputType"
                  formControlName="newPassword"
                  [matTooltip]="passwordRequirements.join('\n')"
                  [matTooltipDisabled]="resetPwForm.controls['newPassword'].valid"
                  matTooltipPosition = "left"
                  (input)="tooltip.show()"
                  #tooltip="matTooltip">
                <div class="items-center flex">
                  <i class="mx-1 uil"
                    (click)="hidden = !hidden"
                    [ngClass]="{'uil-eye-slash': hidden, 'uil-eye': !hidden }">
                  </i>
                </div>
              </div>
              <div
                class="flex border rounded-lg border-drdpblue-300 shadow-drdpblue-100">
                <div class="rounded-l basis-1/12 flex items-center justify-center bg-drdpblue-300 text-white">
                  <i class="uil uil-lock"></i>
                </div>
                <input
                  class="form-control basis-11/12 appearance-none w-5/6 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  maxlength="250"
                  [placeholder]="t('resetPassword.confirmPasswordPlaceholder')"
                  [type]="confirmInputType"
                  formControlName="confirmPassword">
                <div class="items-center flex">
                  <i
                    class="mx-1 uil"
                    (click)="confirmHidden = !confirmHidden"
                    [ngClass]="{'uil-eye-slash': confirmHidden, 'uil-eye': !confirmHidden }">
                  </i>
                </div>
              </div>
              @if (resetPwForm.controls['newPassword'].touched && resetPwForm.controls['confirmPassword'].errors?.passwordMismatch) {
                <span
                  class="text-center text-sm text-red-700">
                  {{ t('resetPassword.mismatch') }}
                </span>
              }
              @if (resetFailed) {
                <div class=" bg-[#F3DEDE] py-1 text-center">
                  <p>{{ t('resetPassword.failed') }}</p>
                </div>
              }
            </div>
          </div>
        </form>
      }
    </div>
  </div>
  <div class="spacer"></div>
  <div mat-dialog-actions class="flex">
    @if (!createPassword) {
      <drdp-btn color="blue" mat-button mat-dialog-close (click)="resetConfirm()" cdkFocusInitial>
        {{ t('resetPassword.resetAndConfirm') }}
      </drdp-btn>
    }
    @if (!createPassword) {
      <drdp-btn class="mx-3" color="blue" mat-button (click)="resetCreate()" cdkFocusInitial>
        {{ t('resetPassword.resetAndCreate') }}
      </drdp-btn>
    } @else {
      <drdp-btn color="blue" mat-button mat-dialog-close (click)="updatePassword()"
        [disabled]="resetPwForm.invalid" cdkFocusInitial>
        {{ t('resetPassword.changePassword') }}
      </drdp-btn>
    }
    <drdp-btn color="cancel" class="ml-3" mat-button mat-dialog-close>
      {{ t('common.cancel') }}
    </drdp-btn>
  </div>
</div>
</ng-container>
